import{m as e}from"./chunk-HBP5N4FR.js";e();function u(n){return new Promise(o=>{setTimeout(()=>o(),n)})}export{u as a};
//# sourceMappingURL=chunk-NJVX7KSK.js.map
